module.exports = __webpack_public_path__ + "static/media/card1_5.25d3e0d5.png";